// extracted by mini-css-extract-plugin
export default {"containerFooter":"styles_containerFooter__T+lwu","contentFooter":"styles_contentFooter__lA6y-","textFirmName":"styles_textFirmName__RxQ0L"};